import actionsTypes from 'store/actionTypes';
import {
  Action,
  ChecklistFolderList,
  ChecklistFolderSortOrderFolderTypeInterface,
  ChecklistItemSortOrderItemTypeInterface,
  ChecklistItemUpdateModel,
  ChecklistRemovePostInterface,
  ChecklistUpdatePostInterface,
  ListBodyParam,
  PostApiCallbackRequestType,
  RemoveChecklistItemPostDataInterface,
  RemovePromiseApiRequestType,
} from 'models/index.m';

export const setChecklistFolderList = (
  data: ChecklistFolderList[],
): Action<ChecklistFolderList[]> => ({
  type: actionsTypes.SET_CHECKLIST_FOLDER_LIST,
  payload: data,
});

export const checklistFolderListApiCall = (
  postData: ListBodyParam | null,
): Action<ListBodyParam | null> => ({
  type: actionsTypes.LIST_CHECKLIST_FOLDER,
  payload: postData,
});

export const setChecklistFolderListIsFetching = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_FOLDER_IS_FETCHING,
  payload: status,
});

export const setChecklistFolderIsAdding = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_FOLDER_IS_ADDING,
  payload: status,
});

export const setChecklistIsAdding = (status: boolean): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_IS_ADDING,
  payload: status,
});

export const setChecklistIsUpdating = (status: boolean): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_IS_UPDATING,
  payload: status,
});

export const setChecklistIsRemoving = (status: boolean): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_IS_REMOVING,
  payload: status,
});

export const setChecklistItemIsRemoving = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_ITEM_IS_REMOVING,
  payload: status,
});

export const setChecklistItemIsUpdating = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_ITEM_IS_UPDATING,
  payload: status,
});

export const setChecklistItemIsAddSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_ITEM_ADDING_SUCCESS,
  payload: status,
});

export const setChecklistItemIsUpdateSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_ITEM_UPDATING_SUCCESS,
  payload: status,
});

export const setChecklistIsAddSuccess = (status: boolean): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_ADDING_SUCCESS,
  payload: status,
});

export const setChecklistIsRemoveSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_REMOVING_SUCCESS,
  payload: status,
});

export const setChecklistIsUpdateSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_UPDATING_SUCCESS,
  payload: status,
});

export const setExistChecklistItemsIsAddingSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_EXIST_CHECKLIST_ADDING_SUCCESS,
  payload: status,
});

export const setChecklistItemsIsRemovingSuccess = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.IS_CHECKLIST_ITEM_REMOVING_SUCCESS,
  payload: status,
});

export const setExistChecklistItemIsAdding = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_EXIST_CHECKLIST_ITEM_IS_ADDING,
  payload: status,
});

export const setChecklistFolderIsRemoving = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_FOLDER_IS_REMOVING,
  payload: status,
});
export const setChecklistFolderIsUpdating = (
  status: boolean,
): Action<boolean> => ({
  type: actionsTypes.SET_CHECKLIST_FOLDER_IS_UPDATEING,
  payload: status,
});

export const checklistFolderAddApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.CREATE_CHECKLIST_FOLDER,
  payload: postData,
});

export const checklistFolderRemoveApiCall = (
  postData: RemovePromiseApiRequestType,
): Action<RemovePromiseApiRequestType> => ({
  type: actionsTypes.REMOVE_CHECKLIST_FOLDER,
  payload: postData,
});

export const checklistRemoveApiCall = (
  postData: ChecklistRemovePostInterface,
): Action<ChecklistRemovePostInterface> => ({
  type: actionsTypes.REMOVE_CHECKLIST,
  payload: postData,
});

export const checklistItemRemoveApiCall = (
  postData: RemoveChecklistItemPostDataInterface,
): Action<RemoveChecklistItemPostDataInterface> => ({
  type: actionsTypes.REMOVE_CHECKLIST_ITEM,
  payload: postData,
});

export const checklistItemUpdateApiCall = (
  postData: ChecklistItemUpdateModel,
): Action<ChecklistItemUpdateModel> => ({
  type: actionsTypes.UPDATE_CHECKLIST_ITEM,
  payload: postData,
});

export const checklistFolderUpdateApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.UPDATE_CHECKLIST_FOLDER,
  payload: postData,
});

export const foldersChecklistDataGetApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.FOLDERS_CHECKLIST_DATA,
  payload: postData,
});

export const checklistItemsDataGetApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.CHECKLIST_ITEMS_LIST_DATA,
  payload: postData,
});

export const checklistItemAddApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.CREATE_NEW_CHECKLIST_IN_FOLDER,
  payload: postData,
});

export const existChecklistItemAddApiCall = (
  postData: PostApiCallbackRequestType,
): Action<PostApiCallbackRequestType> => ({
  type: actionsTypes.ADD_ITEM_IN_EXIST_CHECKLIST,
  payload: postData,
});

export const checklistNameUpdateApiCall = (
  postData: ChecklistUpdatePostInterface,
): Action<ChecklistUpdatePostInterface> => ({
  type: actionsTypes.UPDATE_CHECKLIST_NAME,
  payload: postData,
});

export const updateFolderSortOrder = (
  ChecklstFolderOrderPostData: ChecklistFolderSortOrderFolderTypeInterface[],
): Action<ChecklistFolderSortOrderFolderTypeInterface[]> => ({
  type: actionsTypes.UPDATE_CHECKLIST_FOLDER_SORT_ORDER,
  payload: ChecklstFolderOrderPostData,
});

export const updateChecklistItemSortOrder = (
  ChecklstItemOrderPostData: ChecklistItemSortOrderItemTypeInterface[],
): Action<ChecklistItemSortOrderItemTypeInterface[]> => ({
  type: actionsTypes.UPDATE_CHECKLIST_ITEM_SORT_ORDER,
  payload: ChecklstItemOrderPostData,
});
